import {LabelKey} from 'react-phone-number-input'
import {TFunction} from '@wix/yoshi-flow-editor'
import EnLocale from 'react-phone-number-input/locale/en.json'

export const getInputPhoneLabels = (t: TFunction): Record<LabelKey, string> => {
  return {
    ...EnLocale,
    AC: t('phone-input.country.AC.label'),
    AD: t('phone-input.country.AD.label'),
    AE: t('phone-input.country.AE.label'),
    AF: t('phone-input.country.AF.label'),
    AG: t('phone-input.country.AG.label'),
    AI: t('phone-input.country.AI.label'),
    AL: t('phone-input.country.AL.label'),
    AM: t('phone-input.country.AM.label'),
    AO: t('phone-input.country.AO.label'),
    AR: t('phone-input.country.AR.label'),
    AS: t('phone-input.country.AS.label'),
    AT: t('phone-input.country.AT.label'),
    AU: t('phone-input.country.AU.label'),
    AW: t('phone-input.country.AW.label'),
    AX: t('phone-input.country.AX.label'),
    AZ: t('phone-input.country.AZ.label'),
    BA: t('phone-input.country.BA.label'),
    BB: t('phone-input.country.BB.label'),
    BD: t('phone-input.country.BD.label'),
    BE: t('phone-input.country.BE.label'),
    BF: t('phone-input.country.BF.label'),
    BG: t('phone-input.country.BG.label'),
    BH: t('phone-input.country.BH.label'),
    BI: t('phone-input.country.BI.label'),
    BJ: t('phone-input.country.BJ.label'),
    BL: t('phone-input.country.BL.label'),
    BM: t('phone-input.country.BM.label'),
    BN: t('phone-input.country.BN.label'),
    BO: t('phone-input.country.BO.label'),
    BQ: t('phone-input.country.BQ.label'),
    BR: t('phone-input.country.BR.label'),
    BS: t('phone-input.country.BS.label'),
    BT: t('phone-input.country.BT.label'),
    BW: t('phone-input.country.BW.label'),
    BY: t('phone-input.country.BY.label'),
    BZ: t('phone-input.country.BZ.label'),
    CA: t('phone-input.country.CA.label'),
    CC: t('phone-input.country.CC.label'),
    CD: t('phone-input.country.CD.label'),
    CF: t('phone-input.country.CF.label'),
    CG: t('phone-input.country.CG.label'),
    CH: t('phone-input.country.CH.label'),
    CI: t('phone-input.country.CI.label'),
    CK: t('phone-input.country.CK.label'),
    CL: t('phone-input.country.CL.label'),
    CM: t('phone-input.country.CM.label'),
    CN: t('phone-input.country.CN.label'),
    CO: t('phone-input.country.CO.label'),
    CR: t('phone-input.country.CR.label'),
    CU: t('phone-input.country.CU.label'),
    CV: t('phone-input.country.CV.label'),
    CW: t('phone-input.country.CW.label'),
    CX: t('phone-input.country.CX.label'),
    CY: t('phone-input.country.CY.label'),
    CZ: t('phone-input.country.CZ.label'),
    DE: t('phone-input.country.DE.label'),
    DJ: t('phone-input.country.DJ.label'),
    DK: t('phone-input.country.DK.label'),
    DM: t('phone-input.country.DM.label'),
    DO: t('phone-input.country.DO.label'),
    DZ: t('phone-input.country.DZ.label'),
    EC: t('phone-input.country.EC.label'),
    EE: t('phone-input.country.EE.label'),
    EG: t('phone-input.country.EG.label'),
    EH: t('phone-input.country.EH.label'),
    ER: t('phone-input.country.ER.label'),
    ES: t('phone-input.country.ES.label'),
    ET: t('phone-input.country.ET.label'),
    FI: t('phone-input.country.FI.label'),
    FJ: t('phone-input.country.FJ.label'),
    FK: t('phone-input.country.FK.label'),
    FM: t('phone-input.country.FM.label'),
    FO: t('phone-input.country.FO.label'),
    FR: t('phone-input.country.FR.label'),
    GA: t('phone-input.country.GA.label'),
    GB: t('phone-input.country.GB.label'),
    GD: t('phone-input.country.GD.label'),
    GE: t('phone-input.country.GE.label'),
    GF: t('phone-input.country.GF.label'),
    GG: t('phone-input.country.GG.label'),
    GH: t('phone-input.country.GH.label'),
    GI: t('phone-input.country.GI.label'),
    GL: t('phone-input.country.GL.label'),
    GM: t('phone-input.country.GM.label'),
    GN: t('phone-input.country.GN.label'),
    GP: t('phone-input.country.GP.label'),
    GQ: t('phone-input.country.GQ.label'),
    GR: t('phone-input.country.GR.label'),
    GT: t('phone-input.country.GT.label'),
    GU: t('phone-input.country.GU.label'),
    GW: t('phone-input.country.GW.label'),
    GY: t('phone-input.country.GY.label'),
    HK: t('phone-input.country.HK.label'),
    HN: t('phone-input.country.HN.label'),
    HR: t('phone-input.country.HR.label'),
    HT: t('phone-input.country.HT.label'),
    HU: t('phone-input.country.HU.label'),
    ID: t('phone-input.country.ID.label'),
    IE: t('phone-input.country.IE.label'),
    IL: t('phone-input.country.IL.label'),
    IM: t('phone-input.country.IM.label'),
    IN: t('phone-input.country.IN.label'),
    IO: t('phone-input.country.IO.label'),
    IQ: t('phone-input.country.IQ.label'),
    IR: t('phone-input.country.IR.label'),
    IS: t('phone-input.country.IS.label'),
    IT: t('phone-input.country.IT.label'),
    JE: t('phone-input.country.JE.label'),
    JM: t('phone-input.country.JM.label'),
    JO: t('phone-input.country.JO.label'),
    JP: t('phone-input.country.JP.label'),
    KE: t('phone-input.country.KE.label'),
    KG: t('phone-input.country.KG.label'),
    KH: t('phone-input.country.KH.label'),
    KI: t('phone-input.country.KI.label'),
    KM: t('phone-input.country.KM.label'),
    KN: t('phone-input.country.KN.label'),
    KP: t('phone-input.country.KP.label'),
    KR: t('phone-input.country.KR.label'),
    KW: t('phone-input.country.KW.label'),
    KY: t('phone-input.country.KY.label'),
    KZ: t('phone-input.country.KZ.label'),
    LA: t('phone-input.country.LA.label'),
    LB: t('phone-input.country.LB.label'),
    LC: t('phone-input.country.LC.label'),
    LI: t('phone-input.country.LI.label'),
    LK: t('phone-input.country.LK.label'),
    LR: t('phone-input.country.LR.label'),
    LS: t('phone-input.country.LS.label'),
    LT: t('phone-input.country.LT.label'),
    LU: t('phone-input.country.LU.label'),
    LV: t('phone-input.country.LV.label'),
    LY: t('phone-input.country.LY.label'),
    MA: t('phone-input.country.MA.label'),
    MC: t('phone-input.country.MC.label'),
    MD: t('phone-input.country.MD.label'),
    ME: t('phone-input.country.ME.label'),
    MF: t('phone-input.country.MF.label'),
    MG: t('phone-input.country.MG.label'),
    MH: t('phone-input.country.MH.label'),
    MK: t('phone-input.country.MK.label'),
    ML: t('phone-input.country.ML.label'),
    MM: t('phone-input.country.MM.label'),
    MN: t('phone-input.country.MN.label'),
    MO: t('phone-input.country.MO.label'),
    MP: t('phone-input.country.MP.label'),
    MQ: t('phone-input.country.MQ.label'),
    MR: t('phone-input.country.MR.label'),
    MS: t('phone-input.country.MS.label'),
    MT: t('phone-input.country.MT.label'),
    MU: t('phone-input.country.MU.label'),
    MV: t('phone-input.country.MV.label'),
    MW: t('phone-input.country.MW.label'),
    MX: t('phone-input.country.MX.label'),
    MY: t('phone-input.country.MY.label'),
    MZ: t('phone-input.country.MZ.label'),
    NA: t('phone-input.country.NA.label'),
    NC: t('phone-input.country.NC.label'),
    NE: t('phone-input.country.NE.label'),
    NF: t('phone-input.country.NF.label'),
    NG: t('phone-input.country.NG.label'),
    NI: t('phone-input.country.NI.label'),
    NL: t('phone-input.country.NL.label'),
    NO: t('phone-input.country.NO.label'),
    NP: t('phone-input.country.NP.label'),
    NR: t('phone-input.country.NR.label'),
    NU: t('phone-input.country.NU.label'),
    NZ: t('phone-input.country.NZ.label'),
    OM: t('phone-input.country.OM.label'),
    PA: t('phone-input.country.PA.label'),
    PE: t('phone-input.country.PE.label'),
    PF: t('phone-input.country.PF.label'),
    PG: t('phone-input.country.PG.label'),
    PH: t('phone-input.country.PH.label'),
    PK: t('phone-input.country.PK.label'),
    PL: t('phone-input.country.PL.label'),
    PM: t('phone-input.country.PM.label'),
    PR: t('phone-input.country.PR.label'),
    PS: t('phone-input.country.PS.label'),
    PT: t('phone-input.country.PT.label'),
    PW: t('phone-input.country.PW.label'),
    PY: t('phone-input.country.PY.label'),
    QA: t('phone-input.country.QA.label'),
    RE: t('phone-input.country.RE.label'),
    RO: t('phone-input.country.RO.label'),
    RS: t('phone-input.country.RS.label'),
    RU: t('phone-input.country.RU.label'),
    RW: t('phone-input.country.RW.label'),
    SA: t('phone-input.country.SA.label'),
    SB: t('phone-input.country.SB.label'),
    SC: t('phone-input.country.SC.label'),
    SD: t('phone-input.country.SD.label'),
    SE: t('phone-input.country.SE.label'),
    SG: t('phone-input.country.SG.label'),
    SH: t('phone-input.country.SH.label'),
    SI: t('phone-input.country.SI.label'),
    SJ: t('phone-input.country.SJ.label'),
    SK: t('phone-input.country.SK.label'),
    SL: t('phone-input.country.SL.label'),
    SM: t('phone-input.country.SM.label'),
    SN: t('phone-input.country.SN.label'),
    SO: t('phone-input.country.SO.label'),
    SR: t('phone-input.country.SR.label'),
    SS: t('phone-input.country.SS.label'),
    ST: t('phone-input.country.ST.label'),
    SV: t('phone-input.country.SV.label'),
    SX: t('phone-input.country.SX.label'),
    SY: t('phone-input.country.SY.label'),
    SZ: t('phone-input.country.SZ.label'),
    TA: t('phone-input.country.TA.label'),
    TC: t('phone-input.country.TC.label'),
    TD: t('phone-input.country.TD.label'),
    TG: t('phone-input.country.TG.label'),
    TH: t('phone-input.country.TH.label'),
    TJ: t('phone-input.country.TJ.label'),
    TK: t('phone-input.country.TK.label'),
    TL: t('phone-input.country.TL.label'),
    TM: t('phone-input.country.TM.label'),
    TN: t('phone-input.country.TN.label'),
    TO: t('phone-input.country.TO.label'),
    TR: t('phone-input.country.TR.label'),
    TT: t('phone-input.country.TT.label'),
    TV: t('phone-input.country.TV.label'),
    TW: t('phone-input.country.TW.label'),
    TZ: t('phone-input.country.TZ.label'),
    UA: t('phone-input.country.UA.label'),
    UG: t('phone-input.country.UG.label'),
    US: t('phone-input.country.US.label'),
    UY: t('phone-input.country.UY.label'),
    UZ: t('phone-input.country.UZ.label'),
    VA: t('phone-input.country.VA.label'),
    VC: t('phone-input.country.VC.label'),
    VE: t('phone-input.country.VE.label'),
    VG: t('phone-input.country.VG.label'),
    VI: t('phone-input.country.VI.label'),
    VN: t('phone-input.country.VN.label'),
    VU: t('phone-input.country.VU.label'),
    WF: t('phone-input.country.WF.label'),
    WS: t('phone-input.country.WS.label'),
    XK: t('phone-input.country.XK.label'),
    YE: t('phone-input.country.YE.label'),
    YT: t('phone-input.country.YT.label'),
    ZA: t('phone-input.country.ZA.label'),
    ZM: t('phone-input.country.ZM.label'),
    ZW: t('phone-input.country.ZW.label'),
    ZZ: t('phone-input.country.ZZ.label'),
  }
}
